// Consumer robustness inputs, not current router output. Missing pipeline/digest
// fields and WARM (excluded by today's HOT/MAY query) are explicit negative or
// legacy-compatibility cases. Positive integration uses writerRedditScenarios.json.
import type { EngageLead } from "../../../lib/engageGrouping";

let seq = 0;
const base = (over: Partial<EngageLead> = {}): EngageLead => ({
  id: `lead-${(seq += 1)}`,
  source_url: "https://reddit.com/r/ATLHousing/comments/aaa/moving",
  score: 40,
  verdict: "WARM",
  created_at: "2026-09-19T09:00:00Z",
  body_preview: null,
  context_snippet: null,
  matched_signals: null,
  raw_payload: { subreddit: "r/ATLHousing", title: "A Reddit post" },
  digest_item: null,
  latest_revision: null,
  ...over,
});

/** The post the scorer re-surfaced four times. Only one row should appear. */
const repeatedPost = (createdAt: string): EngageLead =>
  base({
    source_url: "https://reddit.com/r/ATLHousing/comments/repeat/moving-to-atl",
    created_at: createdAt,
    score: 112,
    verdict: "HOT",
    body_preview:
      "Moving to Atlanta next month, need apartment and neighborhood recs (no car, walkable)",
    context_snippet: "mover flagged · walkable=1 · score=112",
    matched_signals: ["mover", "no_car"],
    raw_payload: {
      subreddit: "r/ATLHousing",
      title: "Moving to Atlanta next month, need recs (no car, walkable)",
    },
    // 🔴 NO digest_item — this is the live symptom: the box renders empty.
  });

export const ENGAGE_QUEUE: EngageLead[] = [
  repeatedPost("2026-09-19T08:00:00Z"),
  repeatedPost("2026-09-18T08:00:00Z"),
  repeatedPost("2026-09-17T08:00:00Z"),
  repeatedPost("2026-09-16T08:00:00Z"),

  base({
    source_url: "https://reddit.com/r/ATLHousing/comments/bbb/peachtree",
    score: 88,
    verdict: "HOT",
    created_at: "2026-09-18T12:00:00Z",
    body_preview:
      "Moving in July, want a luxury place on Peachtree, locators aren't responding",
    context_snippet: "locator flagged · luxury=1",
    matched_signals: ["locator", "luxury"],
    raw_payload: {
      subreddit: "r/ATLHousing",
      title: "Locators aren't responding — is that normal?",
    },
    // This one DID get a machine draft, so both states are visible side by side.
    digest_item: {
      suggested_reply_snapshot:
        "That's frustrating — most locators only work a few buildings. Happy to point you at what's actually open on Peachtree.",
    },
  }),

  // A signal the phrase book has never seen — it must be SHOWN, not dropped.
  base({
    source_url: "https://reddit.com/r/Atlanta/comments/ccc/budget",
    score: 21,
    created_at: "2026-09-15T12:00:00Z",
    body_preview: "What does $1,800 get you near the Beltline these days?",
    matched_signals: ["budget", "beltline_adjacent"],
    raw_payload: { subreddit: "r/Atlanta", title: "What does $1,800 get you?" },
  }),
];
